import { render, staticRenderFns } from "./AdminCaracteristicasEditable.vue?vue&type=template&id=7a8ba605&scoped=true"
import script from "./AdminCaracteristicasEditable.vue?vue&type=script&lang=js"
export * from "./AdminCaracteristicasEditable.vue?vue&type=script&lang=js"
import style0 from "./AdminCaracteristicasEditable.vue?vue&type=style&index=0&id=7a8ba605&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8ba605",
  null
  
)

export default component.exports